"use client";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { ThemeProvider } from "@mui/material/styles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { customMuiTheme } from "../utils/AppThemeStyle";
import LazoSnackBarComponent from "./common/LazoSnackBarComponent";

export function AppProviders(props: { children: JSX.Element[] | JSX.Element }) {
  return (
    <ThemeProvider theme={customMuiTheme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <LanguageProvider>
          {props.children}
          <LazoSnackBarComponent />
        </LanguageProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}
